import { ArrowUpRight, Fingerprint, KeyRound, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import VaultAnimation from "./VaultAnimation.jsx";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-grid">
          <div>
            <div className="eyebrow reveal in">QuantumX · Public access</div>
            <h1 className="reveal in d1">
              Your data <em>is yours.</em><br />
              AI <em>without</em><br />
              <em>surveillance.</em>
            </h1>
            <p className="hero-sub reveal in d2">
              Generate images, video, and text with complete privacy. Hash-based authentication.
              No tracking. No storage. No compromise — privacy guaranteed by architecture, not policy.
            </p>
            <div className="hero-cta reveal in d3">
              <button
                onClick={() => navigate('/signup')}
                className="btn btn-primary"
              >
                <span>Get started · $18.95/mo</span>
                <ArrowUpRight size={14} strokeWidth={1.5} />
              </button>
              <a className="btn" href="#architecture">
                <span>See the architecture</span>
                <ArrowUpRight size={14} strokeWidth={1.5} />
              </a>
            </div>
            <div className="hero-meta reveal in d4">
              <div><Fingerprint size={14} strokeWidth={1.5} /> <b>Anon. accounts</b> · no identity link</div>
              <div><KeyRound size={14} strokeWidth={1.5} /> <b>Hash auth</b> · we hold no email</div>
              <div><EyeOff size={14} strokeWidth={1.5} /> <b>Zero retention</b> · nothing logged</div>
            </div>
          </div>

          <div className="vault-stage reveal in d2">
            <div className="vault-head">
              <span>QXAI · VAULT // 01</span>
              <span className="live">SEAL ACTIVE</span>
            </div>
            <div className="vault-canvas">
              <VaultAnimation />
            </div>
            <div className="vault-foot">
              <span>SHA-256 / AES-256-GCM</span>
              <span>NO COPY · NO LEAK</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
